"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const ApiClient_1 = require("../lib/ApiClient");
exports.isContentSetSubjectDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "ContentSetSubjectDetails";
};
class ContentSetProvider extends DataProvider_1.default {
    get fragments() {
        return {
            ContentSetFields: () => `
        id
        userId
        type
        description
        createTime
        modifyTime
        size
        publishTime
        scheduleTime          
        processingStatus  
        taggedUserIds        
      `,
            ContentSet: () => `
        ... on ContentSet {
          ${this.getFragment("ContentSetFields")}
          published
          cover {
            ${this.getFragment("ContentFile")}
          }
        }`,
            SubjectDetails: () => `
        ... on ContentSetSubjectDetails {
          contentSet {
            ${this.getFragment("ContentSet")}
          }
        }
      `,
        };
    }
    search({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.query({
                query: graphql_tag_1.default `
        query ContentSetSearch($data: InputContentSetSearch) {
          contentSetSearch(data: $data) {
            result {
              ${this.getFragment("ContentSet")}
            }
            hasNextPage
            hasPrevPage
            page
            size
            totalPages
            totalRecords
          }
        }
        `,
                variables: { data },
            });
            return resp.data.contentSetSearch;
        });
    }
    findById({ id }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.query({
                query: graphql_tag_1.default `
        query ContentSet($id: ID!) {
          contentSet(id: $id) {
            ${this.getFragment("ContentSet")}
          }
        }
      `,
                variables: { id },
            });
            return resp.data.contentSet;
        });
    }
    create({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("contentSetCreate", { data }, this.getFragment("ContentSet"));
        });
    }
    update({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation ContentSetUpdate($data: InputContentSetUpdate!) {
          contentSetUpdate(data: $data) {
            ${this.getFragment("ContentSet")}
          }
        }
      `,
                variables: { data },
            });
            return resp.data.contentSetUpdate;
        });
    }
    delete({ id }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation ContentSetDelete($id: ID!) {
          contentSetDelete(id: $id)
        }
      `,
                variables: { id },
            });
            return resp.data.contentSetDelete;
        });
    }
    getStatistic({ userIds }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("contentSetStatistic", { userIds });
        });
    }
}
exports.ContentSetProvider = ContentSetProvider;
//# sourceMappingURL=ContentSetProvider.js.map